class VariantSelector extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.toggleExpanded = this.toggleExpanded.bind(this)
    this.buttonTrigger = this.buttonTrigger.bind(this)
    this.selectTrigger = this.selectTrigger.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleFocusOut = this.handleFocusOut.bind(this)

    this.els.button.elements.forEach(buttonEl => {
      this.listeners.add(buttonEl, 'click', this.buttonTrigger)
    })

    this.listeners.add(this.trigger, 'click', this.toggleExpanded)
    this.listeners.add(this.select, 'change', this.selectTrigger)
    this.listeners.add(this, 'keydown', this.handleKeyDown)
    this.listeners.add(this, 'focusout', this.handleFocusOut)
  }

  setExpanded (expanded) {
    const value = expanded ? 'true' : 'false'

    this.setAttribute('aria-expanded', value)
    this.trigger.setAttribute('aria-expanded', value)
  }

  handleKeyDown (event) {
    if (event.key !== 'Escape' || !this.expanded) return

    this.setExpanded(false)
    this.trigger.focus()
  }

  handleFocusOut (event) {
    // Close once focus leaves the dropdown entirely
    if (this.contains(event.relatedTarget)) return

    this.setExpanded(false)
  }

  selectTrigger (event) {
    this.dataset.variantId = event.target.value
  }

  buttonTrigger (event) {
    const variant = event.currentTarget.dataset.id
    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: true,
    })

    this.select.value = variant
    this.select.dispatchEvent(changeEvent)

    if (this.externalEls.wishlistSelect.element.value) {
      this.externalEls.addToWishList.element.removeAttribute('disabled')
    } else {
      this.externalEls.addToWishList.element.setAttribute('disabled', true)
    }

    this.setExpanded(false)
    this.trigger.focus()
  }

  toggleExpanded () {
    const willExpand = !this.expanded

    this.setExpanded(willExpand)

    if (willExpand) this.els.button.elements[0]?.focus()
  }

  get select () {
    return this.els.select.element
  }

  get trigger () {
    return this.els.trigger.element
  }

  get expanded () {
    return this.getAttribute('aria-expanded') === 'true'
  }
}

if (!customElements.get('variant-selector')) {
  customElements.define('variant-selector', VariantSelector)
}
